import React, { ElementType, FC } from "react";
import classNames from "classnames";

/**
 * Proposal for a Label component. We should consider making this an
 * official Kaleidoscope component
 */

interface ILabelProps {
  /**
   * Sepcify the html element rendered by the label. Defaults to a `<span>`
   */
  as?: ElementType;
  size?: LabelSize;
  /**
   * Truncates label overflow with ellipsis
   */
  truncate?: boolean;
  tone?: LabelTone;
  align?: LabelAlign;
  htmlFor?: string;
  id?: string;
  hidden?: boolean;
  className?: string;
}

export enum LabelSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum LabelAlign {
  Start = "start",
  Center = "center",
}

export enum LabelTone {
  Auto = "auto",
  Normal = "normal",
  Secondary = "secondary",
}

const Heading: FC<ILabelProps> = ({
  children,
  as: Component,
  size = LabelSize.Medium,
  align = LabelAlign.Start,
  tone = LabelTone.Normal,
  truncate,
  htmlFor,
  id,
  hidden,
  className,
}) => {
  const LabelElement = Component || `label`;

  return (
    <LabelElement
      className={classNames(
        className,
        "kl-label",
        `kl-label--size-${size}`,
        `kl-label--align-${align}`,
        `kl-label--tone-${tone}`,
        {
          "kl-label--hidden": hidden,
          "kl-label--truncate": truncate,
        },
      )}
      htmlFor={htmlFor}
      id={id}
    >
      {children}
    </LabelElement>
  );
};

export default Heading;
